module.exports = __webpack_public_path__ + "static/media/400117_02.8beaac37.png";